module.exports = __webpack_public_path__ + "img/leftFlip@2x.2f080a65.png";